import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const PublicRoute = () => {
  const session = useSelector((state) => state.session);
  return session !== null ? <Navigate to="/" /> : <Outlet />;
};

export default PublicRoute;
